<template>
  <div class="mt-8">
    <px-indicadores-marketplace-header @change="onChangeDate"/>
    <div v-if="!loading && selectedDate">
      <div>
        <v-row>
          <v-col cols="12" sm="6">
            <px-indicadores-marketplace-vendas-dia :state-date="selectedDate"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-indicadores-marketplace-vendas-categoria :state-date="selectedDate"/>
          </v-col>
        </v-row>
      </div>
      <v-row no-gutters class="mt-2">
        <v-col cols="12" sm="7">
          <px-indicadores-marketplace-listagem-vendas :data-mes="selectedDate"/>
        </v-col>
        <v-col cols="12" sm="5">
          <px-indicadores-marketplace-comissao class="ml-3" :state-date="selectedDate"/>
          <px-indicadores-marketplace-vendas-situacao class="ml-3 mt-5"
                                                      :state-date="selectedDate"/>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-5">
        <v-col cols="12" sm="6">
          <px-indicadores-marketplace-vendas-dia-semana class="mr-2"
                                                        :state-date="selectedDate"/>
        </v-col>
        <v-col cols="12" sm="6">
          <px-indicadores-marketplace-vendas-semana-mes class="ml-2"
                                                        :state-date="selectedDate"/>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-5">
        <v-col cols="12">
          <px-indicadores-marketplace-listagem-ofertas :data-mes="selectedDate"/>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import IndicadoresMarketplaceListagemVendas from './IndicadoresMarketplaceListagemVendas.vue';
import IndicadoresMarketplaceHeader from './IndicadoresMarketplaceHeader.vue';
import IndicadoresMarketplaceVendasDia from './IndicadoresMarketplaceVendasDia.vue';
import IndicadoresMarketplaceVendasSituacao from './IndicadoresMarketplaceVendasSituacao.vue';
import IndicadoresMarketplaceVendasCategoria from './IndicadoresMarketplaceVendasCategoria.vue';
import IndicadoresMarketplaceComissao from './IndicadoresMarketplaceComissao.vue';
import IndicadoresMarketplaceVendasDiaSemana from './IndicadoresMarketplaceVendasDiaSemana.vue';
import IndicadoresMarketplaceVendasSemanaMes from './IndicadoresMarketplaceVendasSemanaMes.vue';
import IndicadoresMarketplaceListagemOfertas
  from './ofertas-vendidas/IndicadoresMarketplaceListagemOfertas.vue';

export default {
  data() {
    return {
      loading: false,
      selectedDate: null,
    };
  },
  methods: {
    onChangeDate(dateState) {
      this.selectedDate = dateState;
    },
  },
  components: {
    pxIndicadoresMarketplaceListagemVendas: IndicadoresMarketplaceListagemVendas,
    pxIndicadoresMarketplaceHeader: IndicadoresMarketplaceHeader,
    pxIndicadoresMarketplaceVendasDia: IndicadoresMarketplaceVendasDia,
    pxIndicadoresMarketplaceVendasSituacao: IndicadoresMarketplaceVendasSituacao,
    pxIndicadoresMarketplaceVendasCategoria: IndicadoresMarketplaceVendasCategoria,
    pxIndicadoresMarketplaceComissao: IndicadoresMarketplaceComissao,
    pxIndicadoresMarketplaceVendasDiaSemana: IndicadoresMarketplaceVendasDiaSemana,
    pxIndicadoresMarketplaceVendasSemanaMes: IndicadoresMarketplaceVendasSemanaMes,
    pxIndicadoresMarketplaceListagemOfertas: IndicadoresMarketplaceListagemOfertas,
  },
};
</script>
